// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"hSe7e":[function(require,module,exports,__globalThis) {
/**
 * Custom Sticky Column Handler for Smooth Scroll
 * Implements sticky behavior for enterprise-left column
 * since position: sticky doesn't work with transform-based scrolling
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class StickyColumn {
    constructor(){
        this.stickyElement = null;
        this.stickyParent = null;
        this.isActive = false;
        this.topOffset = 0;
        this.init();
    }
    init() {
        // Wait for DOM and smooth scroll to be ready
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>this.setup());
        else // Small delay to ensure smooth scroll is initialized
        setTimeout(()=>this.setup(), 100);
    }
    setup() {
        this.stickyElement = document.querySelector('.enterprise-left');
        if (!this.stickyElement) {
            console.warn('Sticky element (.enterprise-left) not found');
            return;
        }
        // Find the parent section
        this.stickyParent = this.stickyElement.closest('.content-section');
        if (!this.stickyParent) {
            console.warn('Parent section not found');
            return;
        }
        // Check if touch device or mobile screen size
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const isMobile = window.innerWidth <= 1024;
        // Disable sticky on touch devices or mobile screens
        if (isTouchDevice || isMobile) {
            console.log('Touch device or mobile detected - sticky column disabled');
            return;
        }
        this.topOffset = window.innerHeight * 0.01; // 4.5vh - closer to top
        // Remove CSS sticky positioning since we're handling it manually
        this.stickyElement.style.position = 'relative';
        this.stickyElement.style.top = '0';
        // Start monitoring
        this.start();
    }
    updatePosition() {
        if (!this.stickyElement || !this.stickyParent || !window.smoothScroll) return;
        const scrollY = window.smoothScroll.scrollCurrent;
        // Get section boundaries
        const sectionTop = this.stickyParent.offsetTop;
        const sectionBottom = sectionTop + this.stickyParent.offsetHeight;
        const stickyHeight = this.stickyElement.offsetHeight;
        // Calculate the sticky position
        const viewportTop = scrollY;
        const viewportBottom = scrollY + window.innerHeight;
        // When to start sticking (section enters viewport)
        const stickStart = sectionTop - this.topOffset;
        // When to stop sticking (bottom of sticky element reaches bottom of section)
        const stickEnd = sectionBottom - stickyHeight - this.topOffset;
        if (scrollY >= stickStart && scrollY <= stickEnd) {
            // Stick to viewport
            const translateY = scrollY - sectionTop + this.topOffset;
            this.stickyElement.style.transform = `translate3d(0, ${translateY}px, 0)`;
            this.stickyElement.style.willChange = 'transform';
        } else if (scrollY > stickEnd) {
            // Pin to bottom of section
            const translateY = sectionBottom - sectionTop - stickyHeight;
            this.stickyElement.style.transform = `translate3d(0, ${translateY}px, 0)`;
            this.stickyElement.style.willChange = 'transform';
        } else {
            // Reset to natural position
            this.stickyElement.style.transform = 'translate3d(0, 0, 0)';
            this.stickyElement.style.willChange = 'auto';
        }
    }
    start() {
        if (this.isActive) return;
        this.isActive = true;
        this.animate();
    }
    animate() {
        if (!this.isActive) return;
        this.updatePosition();
        requestAnimationFrame(()=>this.animate());
    }
    stop() {
        this.isActive = false;
    }
    destroy() {
        this.stop();
        if (this.stickyElement) {
            this.stickyElement.style.position = '';
            this.stickyElement.style.top = '';
            this.stickyElement.style.transform = '';
            this.stickyElement.style.willChange = '';
        }
    }
}
// Initialize sticky column
const stickyColumn = new StickyColumn();
// Expose for debugging
window.stickyColumn = stickyColumn;
exports.default = stickyColumn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["hSe7e"], "hSe7e", "parcelRequire8c58", {})

//# sourceMappingURL=jribh.github.io.05c97bb2.js.map
